import {AfterViewInit, Component} from '@angular/core';
import {Compbaser} from "../../../components/compbaser/compbases";
import {TranslocoService} from "@ngneat/transloco";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {animate, style, transition, trigger} from "@angular/animations";
import {StoreSelectorsService} from "../../../services";
import {ToastrService} from "ngx-toastr";
import {EnumLoginViewMode, ICart, ICartCreate, ICartProduct, ICartReply, IUser} from "../../../interfaces";
import {LocalStoreService} from "../../../services/local-store.service";
import {UserService} from "../../../services/user.service";
import {
    actionCreditCardPaymentCompleted,
    actionLoadCartContentRequest,
    actionLoginViewMode
} from "../../../store/actions/user.actions";
import {FintechService} from "../../../services/fintech.service";
import {take} from "rxjs/operators";
import {of, switchMap} from "rxjs";
import {ofType} from "@ngrx/effects";
import {ActionsSubject} from "@ngrx/store";

@Component({
    selector: 'app-checkout',
    styleUrls: [`./checkout.component.scss`],
    templateUrl: './checkout.component.html',
    animations: [
        trigger(
            'inOutAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({height: 0, opacity: 0}),
                        animate('1s ease-out',
                            style({height: 150, opacity: 1}))
                    ]
                ),
                transition(
                    ':leave',
                    [
                        style({height: 150, opacity: 1}),
                        animate('1s ease-in',
                            style({height: 0, opacity: 0}))
                    ]
                )
            ]
        )
    ]
})

export class CheckoutComponent extends Compbaser implements AfterViewInit {
    cartProducts: Array<ICartProduct>;
    navigationEnd: NavigationEnd;
    cartCreate: ICartCreate;
    addedProduct: string = null;
    m_viewMod = EnumLoginViewMode;
    user: IUser;



    // Cart
    cart: ICart;



    constructor(private translocoService: TranslocoService, private localStoreService: LocalStoreService, private userService: UserService,
                private router: Router, private route: ActivatedRoute, private storeSelector: StoreSelectorsService, private toastr: ToastrService,
                private actionsSubj: ActionsSubject,
                public fintechService: FintechService) {
        super();
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                // this.enterpriseMode = i_user.enterprise;
                // this.dashboard = i_user.dashboard;
                this.user = user;
            })
        );
        this.cod(
            this.storeSelector.getCartProducts().subscribe((v) => {
                this.cartProducts = v;
            })
        );
        this.cod(
            this.router.events.subscribe((e) => {
                if (e instanceof NavigationEnd) {
                    this.navigationEnd = e;
                }
            })
        );
        // this.cod(
        //     this.route.paramMap.subscribe((routeParams) => {
        //         if (routeParams.get('id')) {
        //             this.onAddCart(routeParams.get('id'));
        //         }
        //     })
        // );


        let finalOrderId = null;
        this.cod(this.actionsSubj.pipe(
            ofType(actionCreditCardPaymentCompleted),
            switchMap(reply => {
                const cartProductReply: ICartReply = reply.payload;

                finalOrderId = cartProductReply.finalOrderId;

                console.log('CreditCard: ' + cartProductReply.cartId + ' ' + cartProductReply.finalOrderId);


                if (cartProductReply.finalOrderId == null || cartProductReply.finalOrderId == "") {
                    this.toastr.error(this.translocoService.translate('toast.creditCardTransactionFailed', {}, this.translocoService.getActiveLang()));
                    return of(null);
                } else {
                    this.localStoreService.removeCartStorage();
                    let orderId;
                    this.cart.cartContent.forEach(content => {
                        orderId = (<any> content).order_id;
                    });

                    return this.fintechService.createOrderInfo(orderId).pipe(
                        switchMap(res => {
                            this.toastr.info(this.translocoService.translate('toast.creditCardTransactionPassed', {}, this.translocoService.getActiveLang()));
                            setTimeout(() => {
                                this.router.navigate([`/orders/${finalOrderId}`]);
                            }, 2000);
                            return of('succeeded');
                        })
                    );
                }
            })
        ).subscribe());


        const obs$ = this.fintechService.getFintechInfo();
        this.cod(obs$.subscribe());
    }

    ngAfterViewInit() {
    }

    placeOrder(){
    }

    setViewMode(v: EnumLoginViewMode) {
        this.storeSelector.dispatch(actionLoginViewMode({loginViewMode: v}));
        // this.m_currentViewMode = v;
    }

    navigateTo(link) {
        switch (link){
            case 'products': {
                // const routeTo = this.isProductInUrl() ? '../../products' : '../products';
                // this.router.navigate([routeTo], {relativeTo: this.route});
                break;
            }
            case 'checkout': {
                // const routeTo = this.isProductInUrl() ? '../../checkout' : '../checkout';
                // this.router.navigate([routeTo], {relativeTo: this.route});
                break;
            }

        }

    }



    canCheckout() {
        return !this.fintechService.busy && this.fintechService.editMode == 'info';
    }

    orderOpacity() {
        return this.canCheckout() ? 1.0 : 0.2;
    }

    onOrderCheckout() {
        this.storeSelector.getUser().pipe(
            take(1),
            switchMap( user => {
                this.user = user;
                this.cartCreate = this.localStoreService.getCartCreate();
                return this.storeSelector.getCart();
            }),
            switchMap(cart => {
                this.cart = cart;
                return of('a');
            })
        ).subscribe( a => {
            this.storeSelector.dispatch(actionLoadCartContentRequest({
                cartRequest: {
                    serverCall: "CHECKOUT_CREDIT_CARD",
                    shipping: this.cart.cartLocation.split(':')[1],
                    payerId: this.user.payerId,
                    cartCreate: this.cartCreate,
                    user: this?.user?.username,
                    password: this?.user?.passwordNew,
                    cart: this.cart
                }
            }));
        });

    }

}
